import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActionConfirmationConfig } from '../../../shared/components/action-confirmation-modal/action-confirmation-modal.config';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-ghostc-nonghost-delete',
    templateUrl: './ghostc-nonghost-delete.component.html',
    styleUrls: ['./ghostc-nonghost-delete.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GhostcNonghostDeleteComponent implements OnInit, OnDestroy {
  
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();
  private readonly subs = new Subscription();

  filterParams: any = {};
  globalParams: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  rowData: any = {};
  
  actionConfig: ActionConfirmationConfig | null = null;

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.buildConfig();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.buildConfig();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.buildConfig();
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || {};
    this.filterParams = normalizeFilterParams(activeScreen) || {};
    this.rowData = rowPayloadFromActiveScreen(activeScreen) || {};
  }
  
  private buildConfig() {
    if (!this.GENERAL_CONFIG || !this.rowData || !Object.keys(this.rowData).length) {
      return;
    }

    this.actionConfig = {
      modalTitle: 'Delete Payment',
      confirmationMessage: '',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      successMessage: 'The recipient was successfully deleted',
      errorMessagePrefix: 'Error deleting data',
      actionCode: 'eqf8is',
      contentType: 'urlencoded',
      responseFormat: 'callSuccess',
      payloadMapping: {
        'rp_seq_id': 'SCHEDULE_C_SEQUENCE'
      },
      baseUrl: this.GENERAL_CONFIG.base_url,
      globalParams: this.globalParams,
      filterParams: this.filterParams,
      rowData: this.rowData,
      ssoId: this.USER_SETTINGS?.user?.sso_id || '',
      refreshEventDetail: {}
    };
  }
  
  onConfirmed() {
    this.requestGridUpdate.emit('refresh');
  }
  
  onCancelled() {
    this.dispatchCancelEvent();
  }
  
  onClosed() {
    this.dispatchCancelEvent();
  }
  
  private dispatchCancelEvent() {
    // Dispatch custom event for AngularJS to close modal
    const customEvent = new CustomEvent('cancel-form', {
      detail: 'cancel',
      bubbles: true
    });
    document.querySelector('gtw-ghostc-nonghost-delete-ce')?.dispatchEvent(customEvent);
  }
}
